import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

/* Fetch all admin users with their permissions */
export const fetchUsersWithPermissions = createAsyncThunk(
  "permission/fetchUsersWithPermissions",
  async (_, thunkAPI) => {
    try {
      const res = await api.get("/api/permission/users-with-permissions", authHeader());
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch permissions");
    }
  }
);

/* Fetch single user permissions */
export const fetchUserPermissions = createAsyncThunk(
  "permission/fetchUserPermissions",
  async (userId, thunkAPI) => {
    try {
      const res = await api.get(`/api/permission/${userId}`, authHeader());
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch user permissions");
    }
  }
);

/* Save permissions */
export const savePermissions = createAsyncThunk(
  "permission/save",
  async ({ userId, permissions }, thunkAPI) => {
    try {
      const res = await api.post("/api/permission/save", { userId, permissions }, authHeader());
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to save permissions");
    }
  }
);

const permissionSlice = createSlice({
  name: "permission",
  initialState: {
    usersWithPermissions: [],
    loading: false,
    saveSuccess: false,
    error: null,
  },
  reducers: {
    resetPermissionStatus: (state) => {
      state.saveSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* FETCH USERS WITH PERMISSIONS */
      .addCase(fetchUsersWithPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsersWithPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.usersWithPermissions = action.payload;
      })
      .addCase(fetchUsersWithPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* SAVE PERMISSIONS */
      .addCase(savePermissions.pending, (state) => {
        state.loading = true;
        state.saveSuccess = false;
      })
      .addCase(savePermissions.fulfilled, (state) => {
        state.loading = false;
        state.saveSuccess = true;
      })
      .addCase(savePermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPermissionStatus } = permissionSlice.actions;
export default permissionSlice.reducer;